// Textarea auto-resize height

for (const container of document.querySelectorAll(
  ".content-form"
) as NodeListOf<HTMLElement> as any) {
  const textarea = container.getElementsByTagName("textarea");
  const bufferHeight = 3;

  for (let i = 0; i < textarea.length; i++) {
    textarea[i].setAttribute(
      "style",
      "height:" + (textarea[i].scrollHeight + bufferHeight) + "px"
    );
    textarea[i].addEventListener(
      "input",
      function (this: HTMLElement) {
        this.style.height = "auto";
        this.style.height = this.scrollHeight + bufferHeight + "px";
      },
      false
    );
  }
}
